"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Segment_1 = __importDefault(require("../entity/Segment"));
class SegmentStub extends Segment_1.default {
    constructor({ label = 'ABC', value = 1000 } = {}) {
        super({ label, value });
    }
}
exports.default = SegmentStub;
